import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";

export function getCategoryLabel(state) {
    if (state.categoryFilter && state.categoryFilter.length > 0) {
        if (state.categoryFilter.length === 1) {
            // Keys are lowercase-with-spaces — match case-insensitively
            const matched = (state.categories || []).find(function (c) {
                return c.name.toLowerCase() === state.categoryFilter[0];
            });
            if (matched) {
                return matched.isEditable
                    ? matched.name
                    : i18n.t("category_" + matched.name.toLowerCase().replace(/\s+/g, "_"));
            }
        }
        return state.categoryFilter.length + " " + i18n.t("selected");
    }
    return i18n.t("all_types");
}
export function loadCategories(state) {
    Requester.get(Gateway.public + 'courses/categories')
        .then(function (result) {
            state.categories = result.categories;
        })
        .catch(function (error) {
            Toasts.add('error', i18n.t('error'), i18n.t(error.response?.properties.errorCode));
            state.categories = [];
        });
}
